import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { FindPersonContactMode, usesFindPersonWaterfall } from "@signalist/shared-types";

import { Toggle } from "@/components/Toggle/Toggle";

import { FindPersonContactModeSelector } from "../../ListEditDetails/components/FindPersonContactModeSelector";

interface LeadNoveltySettingProps {
	/** The list's type, which decides which of the two settings it reads. */
	list: { sourceType?: string | null; entityType?: string | null; scrapeLevel?: string | null };
	onlyNewLeads: boolean;
	findPersonContactMode?: FindPersonContactMode;
	onOnlyNewLeadsChange: (value: boolean) => void;
	onFindPersonContactModeChange: (mode: FindPersonContactMode) => void;
}

/**
 * List Settings' "whom may this list add?" (PREC-3899). A list that finds people at its companies
 * (`usesFindPersonWaterfall`, the same predicate the API reads) shows the Find person mode, which
 * replaced "Only new leads" there; every other list keeps the "Only new leads" toggle.
 */
export const LeadNoveltySetting: FunctionComponent<LeadNoveltySettingProps> = ({
	list,
	onlyNewLeads,
	findPersonContactMode,
	onOnlyNewLeadsChange,
	onFindPersonContactModeChange,
}) => {
	const { t } = useTranslation();

	if (usesFindPersonWaterfall(list)) {
		return (
			<FindPersonContactModeSelector
				hint={t("list.detailsStep.contactMode.settingsHint")}
				value={findPersonContactMode ?? FindPersonContactMode.CONTACTS_FIRST}
				onChange={onFindPersonContactModeChange}
			/>
		);
	}

	return (
		<div className="flex flex-col w-full mb-8">
			<div className="flex flex-row items-center gap-8 text-ssm text-text">
				<Toggle
					isChecked={onlyNewLeads}
					name="onlyNewLeads"
					onChange={() => onOnlyNewLeadsChange(!onlyNewLeads)}
				/>
				{t("list.settings.onlyNewLeadsLabel")}
			</div>
		</div>
	);
};
